export default {"src":"/_next/static/media/podcast-light.d624c2cc.svg","height":256,"width":256};